<script lang="ts" setup>
    import { ref, watch, onMounted } from 'vue';
    import ToggleIcon from "./ToggleIcon.vue";

    const props = withDefaults(defineProps<{
        isOpen?: boolean
    }>(), { 
        isOpen: false
    });    

    const emit = defineEmits(["update:isOpen"]);

    const showOptions=ref(false);

    watch(() => props.isOpen, (newVal, _oldVal) => {
        showOptions.value = newVal;
    });

    onMounted(() =>{
        showOptions.value = props.isOpen;
    });

    function toggleOptions(){
        showOptions.value = !showOptions.value;
    }
    function hideOptions(hideOptionsSection: boolean = true) {
        showOptions.value = !hideOptionsSection;
    }    

    defineExpose({toggleOptions, hideOptions});
</script>

<style scoped>
    .OptionsIcon{
        font-size:1.25em;
        padding-right:0.25em
    }
    
    .OptionTitle:hover{
        font-size:1.05em;
    }
</style>

<template>
    <div>
        <span :title="!showOptions ? 'Show Options' : 'Hide Options'" class="OptionTitle me-1">
            <span class="text-primary me-1">
                <ToggleIcon v-model:folded="showOptions" :folded-value="false" @update:folded="state => emit('update:isOpen', state)" />
            </span>

            <slot name="title" />
        </span>

        <slot name="summary"/>
    </div>

    <div v-if="showOptions">
        <slot name="options">
            <span class="text-danger">Missing 'options'</span>
        </slot>
    </div>
</template>